import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import * as fuentesApi from '@/modules/bd-unificada/api/fuentesApi'
import type {
  FuenteCreateInput,
  FuenteUpdateInput,
} from '@/modules/bd-unificada/types/fuente'

export const fuentesKeys = {
  all: ['bd-unificada', 'fuentes'] as const,
  lists: () => [...fuentesKeys.all, 'list'] as const,
  detail: (id: string) => [...fuentesKeys.all, 'detail', id] as const,
}

export function useFuentes() {
  return useQuery({
    queryKey: fuentesKeys.lists(),
    queryFn: () => fuentesApi.getFuentes(),
  })
}

export function useCreateFuente() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: FuenteCreateInput) => fuentesApi.createFuente(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: fuentesKeys.lists() })
      toast.success('Fuente creada exitosamente')
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al crear fuente')
    },
  })
}

export function useUpdateFuente() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: FuenteUpdateInput }) =>
      fuentesApi.updateFuente(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: fuentesKeys.lists() })
      toast.success('Fuente actualizada exitosamente')
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al actualizar fuente')
    },
  })
}
